export default function ServicesSectionEn() {
  const services = [
    {
      icon: 'ri-steering-2-line',
      title: 'Rental Car Driving Support',
      description: 'Professional assistance for driving your rental car safely and comfortably throughout Tokyo and surrounding areas.'
    },
    {
      icon: 'ri-map-2-line',
      title: 'Sightseeing Travel Assist',
      description: 'Support for traveling to tourist destinations, scenic spots, and popular attractions with efficient route planning.'
    },
    {
      icon: 'ri-flight-takeoff-line',
      title: 'Airport Companion Support',
      description: 'Assistance with airport pick-up and drop-off, helping you navigate Tokyo\'s airports and surrounding roads.'
    },
    {
      icon: 'ri-navigation-line',
      title: 'Parking & Highway Navigation',
      description: 'Guidance for parking facilities, highway toll systems, and complex intersections in Tokyo metropolitan area.'
    },
    {
      icon: 'ri-guide-line',
      title: 'Tokyo Local Guidance',
      description: 'Insider knowledge of Tokyo\'s neighborhoods, hidden gems, local restaurants, and cultural insights.'
    }
  ];

  return (
    <section className="py-24 bg-zinc-900">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Our <span className="text-amber-400">Services</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Comprehensive driving assistance tailored to your needs in Tokyo
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-zinc-800/50 backdrop-blur-sm border border-amber-500/20 rounded-2xl p-8 hover:border-amber-500/50 transition-all duration-300 hover:transform hover:scale-105"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-amber-500 to-amber-600 rounded-2xl flex items-center justify-center mb-6">
                <i className={`${service.icon} text-black text-3xl`}></i>
              </div>
              <h3 className="text-2xl font-bold text-white mb-4">{service.title}</h3>
              <p className="text-gray-400 leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}